import {computed, getCurrentInstance, inject} from "vue";

export function excludeSpecial (str) {
	// return str.replace(/°|"|&|<|>|@|À|Á|Â|Ã|Ä|Å|Æ|Ç|È|É|Ê|Ë|Ì|Í|Î|Ï|Ð|Ñ|Ò|Ó|Ô|Õ|Ö|×|Ø|Ù|Ú|Û|Ü|Ý|Þ|ß|à|á|â|ã|ä|å|æ|ç|è|é|ê|ë|ì|í|î|ï|ð|ñ|ò|ó|ô|õ|ö|÷|ø|ù|ú|û|ü|ý|þ|ÿ|Œ|œ|ƒ|–|—|‘|’|‚|“|”|„|‹|›/gi, '');
	return str;
}


export default function TextParse(props) {
	const $nl2br = inject('$nl2br');

	var appContext = getCurrentInstance();


	const escapeHtml = (str) => {
		str = decodeURI(str
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#039;"));

		str = excludeSpecial(str)
		return str;
	}

	const filterSpace = (str) => {
		str = str.split('  ').join(' &#160 ');
		return str
	}
	const textSaying = computed(() => {
		try {
			var nv = props.selectedItems.text_messages.value;
			var ml = props.selectedItems.poster_size.text_saying.max_text_lines;
			var lines = nv.split("\n");
			if (ml < lines.length) {
				lines.length = ml;
			}
			if (lines.length) {
				props.selectedItems.text_messages.value = lines.join("\n");
			}
			return $nl2br(filterSpace(escapeHtml(props.selectedItems.text_messages.value)))
		} catch (e) {
			return '️';
		}
	});

	const textTitle = computed(() => {
		try {
			return $nl2br(filterSpace(escapeHtml(props.selectedItems.text_title.value)));
		} catch (e) {
			return '';
		}
	});

	const textLocation = computed(() => {
		try {
			return $nl2br(filterSpace(escapeHtml(props.selectedItems.text_location.value)));
		} catch (e) {
			return '';
		}
	});

	const textDate = computed(() => {
		try {
			return filterSpace(props.selectedItems.text_date.value);
		} catch (e) {
			return '';
		}
	});

	const textCountry = computed(() => {
		try {
			return filterSpace(props.selectedItems.text_country.value);
		} catch (e) {
			return '';
		}
	});

	const textCity = computed(() => {
		try {
			return filterSpace(props.selectedItems.text_city.value);
		} catch (e) {
			return '';
		}
	});

	const textCoordinate = computed(() => {

		try {
			var v = props.selectedItems.text_coordinates_title.value;
			return filterSpace(v);
		} catch (e) {
			return '';
		}
	});

	const textDateTime = computed(() => {
		var date = textDate.value;

		return date;
	})
	return {
		textSaying,
		textTitle,
		textLocation,
		textDate,
		textCountry,
		textCity,
		textCoordinate,
		textDateTime
	}
}
